/**
 * Comprehensive list of Indian cuisines + popular non-Indian cuisines served
 * widely across India. Used as a master suggestion list for the cuisine
 * tag-input on Restaurant onboarding & owner Settings.
 */
export const INDIAN_CUISINES = [
  // North
  "Punjabi", "Mughlai", "Awadhi", "Lucknowi", "Kashmiri", "Rajasthani", "Marwari",
  "Haryanvi", "Himachali", "Kumaoni", "Garhwali", "Dogri",
  // South
  "South Indian", "Tamil", "Chettinad", "Andhra", "Telangana", "Hyderabadi",
  "Hyderabadi Biryani", "Karnataka", "Mangalorean", "Coorg", "Udupi",
  "Kerala", "Malabar", "Syrian Christian", "Konkan",
  // East
  "Bengali", "Odia", "Bihari", "Maithil", "Bhojpuri", "Jharkhandi",
  "Assamese", "Naga", "Manipuri", "Mizo", "Khasi", "Tripuri", "Sikkimese",
  "Tibetan", "Bhutia", "Nepali",
  // West
  "Gujarati", "Kathiyawadi", "Maharashtrian", "Malvani", "Kolhapuri",
  "Goan", "Goan Catholic", "Parsi", "Sindhi",
  // Pan-India / regional crossovers
  "North Indian", "Indian Chinese", "Indo-Chinese", "Mughal-Indian",
  "Street Food", "Chaat", "Biryani", "Tandoor", "Kebab", "Dhaba",
  // Veg/diet styles
  "Pure Vegetarian", "Jain", "Sattvic", "Vegan",
  // Non-Indian widely served in India
  "Asian", "Pan-Asian", "Chinese", "Cantonese", "Schezwan", "Sichuan",
  "Japanese", "Sushi", "Ramen", "Korean", "Thai", "Vietnamese",
  "Singaporean", "Malaysian", "Indonesian", "Burmese",
  "Italian", "Neapolitan", "Mediterranean", "Lebanese", "Turkish",
  "Mexican", "American", "BBQ", "Continental", "European",
  "Modern European", "French", "Spanish", "Greek",
  "Middle Eastern", "Arabic", "Persian", "Afghani",
  // Format / drinks
  "Cafe", "Bakery", "Patisserie", "Desserts", "Ice Cream", "Confectionery",
  "Beverages", "Tea", "Coffee", "Cocktails", "Wine Bar", "Brewery",
  "Seafood", "Grill", "Fast Food", "Quick Bites", "Healthy", "Bowl Food",
];
